(function () {
    'use strict';

    angular.module('sempraWebapp').factory('moneyChangerJournalActions', moneyChangerJournalActionsFactory);

    /** @ngInject */
    function moneyChangerJournalActionsFactory(api, $q) {
        return {
            getJournalEntries: getJournalEntries,
            getChangers: getChangers
        };

        function getJournalEntries(siteId, facilityId, deviceKey, from, to, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getMoneyChangerJournalEntries(siteId, facilityId, deviceKey, from, to, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getChangers(siteId) {
            var deferred = $q.defer();
            api.getMoneyChangerJournalChangers(siteId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }
    }
})();
